import './NeighborhoodGuideHeroCard.scss';
import { NeighborhoodGuideHeroCardProps } from './NeighborhoodGuideHeroCard.types';
import { Children, SanityTextBody } from '../../CityGuide/CityGuide.types';

function NeighborhoodGuideHeroCard({ neighborhood, quintessentialExperience, innerClassName }: NeighborhoodGuideHeroCardProps) {
  return (
    <div className={`neighborhood-guide-hero-card ${innerClassName}`}>
      <div className="neighborhood-guide-hero-card-header">Quintessential {neighborhood}</div>
      <div className="neighborhood-guide-hero-card-body">
        {quintessentialExperience &&
          quintessentialExperience.map((exp: SanityTextBody) => {
            return exp.children.map((child: Children) => {
              return <p className="neighborhood-guide-hero-card-paragraph">{child.text}</p>;
            });
          })}
      </div>
    </div>
  );
}
export default NeighborhoodGuideHeroCard;
